<template>
	<b-tab title="FINÁNCIALO">
		<iframe class="financing-iframe" src="https://financiamiento.macal.cl" scrolling="no"></iframe>
	</b-tab>
</template>

<script>

  export default {
	name: 'v-tab-financing',
	components:{
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.financing-iframe{
		width: 100%; height: 800px !important; border: none;
	}
	@media(max-width: 1120px){
		.financing-iframe{
			width: 100%; height: 1500px !important; border: none;
		}
	}
</style>